import { useCartDrawer } from '@iheartjane/cart';

import { useSearchContext } from '@jane/search/hooks';
import type { ProductCardWithTrackingProps } from '@jane/shared-ecomm/components';
import { ProductCardWithTracking } from '@jane/shared-ecomm/components';
import { useMenu, useSpecials } from '@jane/shared-ecomm/providers';

type MenuProductCardProps = Pick<
  ProductCardWithTrackingProps,
  | 'algoliaIndexName'
  | 'appliedWeightFilter'
  | 'breadcrumbs'
  | 'cardIndex'
  | 'carouselView'
  | 'columnPosition'
  | 'disableWeightFilter'
  | 'maxWeightOption'
  | 'menuRowName'
  | 'product'
  | 'productLocation'
  | 'rowPosition'
  | 'showOnlyWeights'
  | 'weightFilter'
  | 'withoutDrawerOnAddToCart'
  | 'isMenuTopRow'
>;

export const MenuProductCard = (props: MenuProductCardProps) => {
  const { searchState } = useSearchContext();

  const {
    appInfo: { appMode },
    cart,
    dispatches: { attemptToAddToCart, deleteCartItem },
    listView,
    paths,
    store,
    jdid,
  } = useMenu();

  const { specials } = useSpecials();
  const { isOpen: cartIsOpen } = useCartDrawer();

  const cartProducts = cart.products;
  const cartStoreId = cart.store?.id;

  return (
    <ProductCardWithTracking
      appMode={appMode}
      attemptToAddToCart={attemptToAddToCart}
      cartIsOpen={cartIsOpen}
      cartProducts={cartProducts}
      cartStoreId={cartStoreId}
      deleteCartItem={deleteCartItem}
      janeDeviceId={jdid}
      listView={listView}
      pdpPath={paths.menuProduct}
      searchState={searchState}
      specials={specials}
      store={store}
      {...props}
    />
  );
};
